module.exports = __webpack_public_path__ + "media/components/country-flag/static/nc-a3528c81181d8098459220a34959aac3.svg";